import {Button} from '@material-ui/core';
import React from 'react';
import LegacyPortalDialog from '../LegacyPortalDialog';

export type LegacyOkCancelDialogProps = {
  [key: string]: any;
  callback?: (result: number) => void;
  style?: any;
  title?: any;
  message?: any;
  cancelText?: any;
  okText?: any;
};

const LegacyOkCancelDialog = (props: LegacyOkCancelDialogProps) => {
  const result = (value: number) => props.callback && props.callback(value);

  return (
    <LegacyPortalDialog result={result} style={props.style}>
      <span className="ha-dialog-title">{props.title}</span>
      <span className="ha-dialog-body">{props.message}</span>
      <div className="horizontal end-justified">
        {props.cancelText && (
          <Button size="small" className="ha-dialog-cancel" onClick={() => result(1)}>
            {props.cancelText}
          </Button>
        )}
        <Button size="small" className="ha-dialog-done" onClick={() => result(2)}>
          {props.okText || 'OK'}
        </Button>
      </div>
    </LegacyPortalDialog>
  );
};

export default LegacyOkCancelDialog;
